




































































import { Component, Prop, Vue } from 'vue-property-decorator';
import store from '@/store';
import { getModule } from 'vuex-module-decorators';
import { ThemeConfModule } from '@/store/modules/theme';
import Scorm from '@/mixins/Scorm';
import { ThemeConf, ThemConfContent } from '@/types/ThemeConf';
var sanitizeUrlHelper = require('@braintree/sanitize-url').sanitizeUrl;
const Theme = getModule(ThemeConfModule, store);

@Component
export default class ThemedSlide extends Scorm {
  @Prop() enableScrollIndication!: boolean;
  @Prop({ default: false }) isIntro!: boolean;
  slideContent: ThemConfContent | undefined;
  themeConfig: ThemeConf | null = null;
  created() {
    this.themeConfig = Theme.getTheme;
    if (this.themeConfig && this.themeConfig.slides) {
      this.slideContent = this.isIntro
        ? this.themeConfig.slides.intro
        : this.themeConfig.slides.outro;
    }
  }

  get cssVars() {
    return this.themeConfig && this.themeConfig.color_primary
      ? { color: this.themeConfig.color_primary }
      : {};
  }
  get cssIconVars() {
    return this.themeConfig && this.themeConfig.color_primary
      ? { color: this.themeConfig.color_primary , fontFamily:"'Font Awesome 5 Free', 'Font Awesome 5 Brands'"}
      : {};
  }
  sanitizeUrl(url: string) {
    return sanitizeUrlHelper(url);
  }
}
